module.exports = __webpack_public_path__ + "static/aquarell2x-94342f1540fd933df8601977cb746d57.png";